import { render, staticRenderFns } from "./CarAdd.vue?vue&type=template&id=08d8cc46&"
import script from "./CarAdd.vue?vue&type=script&lang=js&"
export * from "./CarAdd.vue?vue&type=script&lang=js&"
import style0 from "./CarAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports